<template>
    <div class="content content-fixed">
        <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                    <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item"><a href="#">Тавтай морил</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Хяналтын самбар</li>
                    </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Шинжлэх ухаан технооги инновацийн нэгдсэн цахим сүлжээ</h4>
                </div>
                <div class="d-none d-md-block">
                    <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase">
                      <feather type="menu"></feather> Эхлэл
                    </button>
                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5">
                      <feather type="menu"></feather> ШУ салбар</button>
                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"> 
                      <feather type="menu"></feather> Төслийн төрлөөр</button>
                </div>
                </div>

















                <div class="row row-xs">
          <div class="col-sm-6 col-lg-3">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Эрдэмтэн</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">810</h3>
              </div>
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Бүтээл</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">3,137</h3>
              </div>
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Ангилал</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">2</h3>
              </div>
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Оноор</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">84</h3>
              </div>
            </div>
          </div><!-- col -->
          <div class="col-lg-8 col-xl-7 mg-t-10">
            <div class="card">
              <div class="card-header pd-y-20 d-md-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Монгол эрдэмтдийн бүтээлийн өгөөж</h6>
                <ul class="list-inline d-flex mg-t-20 mg-sm-t-10 mg-md-t-0 mg-b-0">
                  <li class="list-inline-item d-flex align-items-center">
                    <span class="d-block wd-10 ht-10 bg-df-1 rounded mg-r-5"></span>
                    <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">Зах зээлд нэвтэрсэн</span>
                  </li>
                  <li class="list-inline-item d-flex align-items-center mg-l-5">
                    <span class="d-block wd-10 ht-10 bg-df-2 rounded mg-r-5"></span>
                    <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">Хэвлэгдсэн</span>
                  </li>
                  <li class="list-inline-item d-flex align-items-center mg-l-5">
                    <span class="d-block wd-10 ht-10 bg-df-3 rounded mg-r-5"></span>
                    <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">Туурвисан</span>
                  </li>
                </ul>
              </div><!-- card-header -->
              <div class="card-body pos-relative pd-0">
                <div class="pd-l-20">
                  <div class="row">
                    <div class="col-sm-5">
                      <h3 class="tx-normal tx-rubik tx-spacing--2 mg-b-5">₮620,076</h3>
                      <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-10">Хөрөнгө оруулалт авсан</h6>
                      <p class="mg-b-0 tx-12 tx-color-03">Татан төвлөрүүлсэн дүн сүүлийн жилүүдад тасралтгүй өсч байна <a href="">Дэлгэрэнгүй</a></p>
                    </div><!-- col -->
                    <div class="col-sm-5 mg-t-20 mg-sm-t-0">
                      <h3 class="tx-normal tx-rubik tx-spacing--2 mg-b-5">₮50,200</h3>
                      <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-10">Инновцийн хэмнэлт</h6>
                      <p class="mg-b-0 tx-12 tx-color-03">Хэрэглээнд нэвтэрсэн бүтээлүүдийн бодит өгөөж нь залуу судлаачдад итгэл төрүүлж байна. <a href="">Дэлгэрэнгүй</a></p>
                    </div><!-- col -->
                  </div><!-- row -->
                </div>

                <div class="chart-one">
                  <chart-mixed></chart-mixed>
                </div><!-- chart-one -->
              </div><!-- card-body -->
            </div><!-- card -->
          </div>
          <div class="col-lg-4 col-xl-5 mg-t-10">
            <div class="card">
              <div class="card-header pd-t-20 pd-b-0 bd-b-0">
                <h6 class="mg-b-5">Шинэ нийтлэлүүд</h6>
                <p class="tx-12 tx-color-03 mg-b-0">Хамгийн их санхүүжилт хийгдсэн шинжлэх ухааны салбарууд.</p>
              </div><!-- card-header -->
              <div class="card-body pd-20">
                <div class="chart-two mg-b-20">
                  <chart-mixed1></chart-mixed1>
                </div><!-- chart-two -->
                <div class="row">
                  <div class="col-sm">
                    <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-5">₮1,680<small>.50</small></h4>
                    <p class="tx-11 tx-uppercase tx-spacing-1 tx-semibold mg-b-10 tx-primary">Олгогдсон</p>
                    <div class="tx-12 tx-color-03">Үр дүнгээ хүлээлгэн өгсөн судалгаа боловсруулалтын ажил.</div>
                  </div><!-- col -->
                  <div class="col-sm mg-t-20 mg-sm-t-0">
                    <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-5">₮1,520<small>.00</small></h4>
                    <p class="tx-11 tx-uppercase tx-spacing-1 tx-semibold mg-b-10 tx-pink">санхүүжилт</p>
                    <div class="tx-12 tx-color-03">Эрдэм шинжилгээний байгууллагуудын хэрэгжүүлсэн төслийн тоо санхүүжилт.</div>
                  </div><!-- col -->
                </div><!-- row -->
              </div><!-- card-body -->
            </div><!-- card -->
          </div>
          <div class="col-xl-4 mg-t-10 order-md-1 order-xl-0">
            <div class="card ht-lg-100p">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Монгол эрдэмтдийн бүтээл олон улсад</h6>
                <!-- <div class="tx-13 d-flex align-items-center">
                  <span class="mg-r-5">Country:</span> <a href="" class="d-flex align-items-center link-03 lh-0">USA <i class="icon ion-ios-arrow-down mg-l-5"></i></a>
                </div> -->
              </div><!-- card-header -->
              <div class="card-body pd-0">
                <div class="">
                  <iframe style="width: 100%; border: 0; height: 200px" src="/html/mori/map.html"></iframe>
                </div>
                <div class="table-responsive">
                  <table class="table table-borderless table-dashboard table-dashboard-one">
                    <thead>
                      <tr>
                        <th class="wd-40">Улс</th>
                        <th class="wd-25 text-right">Тоо</th>
                        <th class="wd-35 text-right">Хөрөнгө оруулалт</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="tx-medium">ОХУ</td>
                        <td class="text-right">12,201</td>
                        <td class="text-right">₮150,200.80</td>
                      </tr>
                      <tr>
                        <td class="tx-medium">АНУ</td>
                        <td class="text-right">11,950</td>
                        <td class="text-right">₮138,910.20</td>
                      </tr>
                      <tr>
                        <td class="tx-medium">БНХАУ</td>
                        <td class="text-right">11,198</td>
                        <td class="text-right">₮132,050.00</td>
                      </tr>
                      <tr>
                        <td class="tx-medium">Солонгос</td>
                        <td class="text-right">9,885</td>
                        <td class="text-right">₮127,762.10</td>
                      </tr>
                      <tr>
                        <td class="tx-medium">Япон</td>
                        <td class="text-right">8,560</td>
                        <td class="text-right">₮117,087.50</td>
                      </tr>
                    </tbody>
                  </table>
                </div><!-- table-responsive -->
              </div><!-- card-body -->
            </div><!-- card -->
          </div><!-- col -->
          <div class="col-xl-8 mg-t-10">
            <div class="card mg-b-10">
              <div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                <div>
                  <h6 class="mg-b-5">Төслийн тоо, санхүүжилт</h6>
                  <p class="tx-13 tx-color-03 mg-b-0">Монгол эрдэмтдийн шилдэг бүтээлүүд</p>
                </div>
                <div class="d-flex mg-t-20 mg-sm-t-0">
                  <div class="btn-group flex-fill">
                    <button class="btn btn-white btn-xs active">Хугацаагаар</button>
                    <button class="btn btn-white btn-xs">Үнэлгээгээр</button>
                  </div>
                </div>
              </div><!-- card-header -->
              <div class="card-body pd-y-30">
                <div class="d-sm-flex">
                  <div class="media">
                    <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-teal tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                    </div>
                    <div class="media-body">
                      <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Их дээд сургуулиуд</h6>
                      <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">₮1,958,104</h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                    </div>
                    <div class="media-body">
                      <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Салбарын байгууллагууд</h6>
                      <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">₮234,769<small>.50</small></h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                    </div>
                    <div class="media-body">
                      <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Хувийн хэвшил, ТББ, бусад</h6>
                      <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">₮1,608,469<small>.50</small></h4>
                    </div>
                  </div>
                </div>
              </div><!-- card-body -->
              <div class="table-responsive">
                <table class="table table-dashboard mg-b-0">
                  <thead>
                    <tr>
                      <th>Төрөл</th>
                      <th class="text-right">Тоо</th>
                      <th class="text-right">Нийт дүн</th>
                      <th class="text-right">Татвар</th>
                      <th class="text-right">Санхүүжилт</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="tx-color-03 tx-normal">Захилгат төсөл</td>
                      <td class="tx-medium text-right">1,050</td>
                      <td class="text-right tx-teal">+ ₮32,580.00</td>
                      <td class="text-right tx-pink">- ₮3,023.10</td>
                      <td class="tx-medium text-right">₮28,670.90 <span class="mg-l-5 tx-10 tx-normal tx-success"><i class="icon ion-md-arrow-up"></i> 4.5%</span></td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">Суурь судалгааны төсөл</td>
                      <td class="tx-medium text-right">980</td>
                      <td class="text-right tx-teal">+ ₮30,065.10</td>
                      <td class="text-right tx-pink">- ₮2,780.00</td>
                      <td class="tx-medium text-right">₮26,930.40  <span class="mg-l-5 tx-10 tx-normal tx-danger"><i class="icon ion-md-arrow-down"></i> 0.8%</span></td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">Инновацийн төсөл</td>
                      <td class="tx-medium text-right">980</td>
                      <td class="text-right tx-teal">+ ₮30,065.10</td>
                      <td class="text-right tx-pink">- ₮2,780.00</td>
                      <td class="tx-medium text-right">₮26,930.40  <span class="mg-l-5 tx-10 tx-normal tx-danger"><i class="icon ion-md-arrow-down"></i> 0.8%</span></td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">ШУА-ийн грант</td>
                      <td class="tx-medium text-right">980</td>
                      <td class="text-right tx-teal">+ ₮30,065.10</td>
                      <td class="text-right tx-pink">- ₮2,780.00</td>
                      <td class="tx-medium text-right">₮26,930.40  <span class="mg-l-5 tx-10 tx-normal tx-danger"><i class="icon ion-md-arrow-down"></i> 0.8%</span></td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">Докторын дараах инноваци</td>
                      <td class="tx-medium text-right">980</td>
                      <td class="text-right tx-teal">+ ₮30,065.10</td>
                      <td class="text-right tx-pink">- ₮2,780.00</td>
                      <td class="tx-medium text-right">₮26,930.40  <span class="mg-l-5 tx-10 tx-normal tx-danger"><i class="icon ion-md-arrow-down"></i> 0.8%</span></td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">Цөм технологийн төсөл</td>
                      <td class="tx-medium text-right">980</td>
                      <td class="text-right tx-teal">+ ₮30,065.10</td>
                      <td class="text-right tx-pink">- ₮2,780.00</td>
                      <td class="tx-medium text-right">₮26,930.40  <span class="mg-l-5 tx-10 tx-normal tx-danger"><i class="icon ion-md-arrow-down"></i> 0.8%</span></td>
                    </tr>
                  </tbody>
                </table>
              </div><!-- table-responsive -->
            </div><!-- card -->

            <div class="card card-body ht-lg-100">
              <div class="media">
                <span class="tx-color-04"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download wd-60 ht-60"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg></span>
                <div class="media-body mg-l-20">
                  <h6 class="mg-b-10">Тоон үзүүлэлтийн дэлгэрэнгүй мэдээллийг CSV форматаар татаж авах.</h6>
                  <p class="tx-color-03 mg-b-0">Дээр статистиктой холбоотой мэдээллийг тодруулах бол info@ac.mn цахим хаягаар бидэнд хандана уу </p>
                </div>
              </div><!-- media -->
            </div>
          </div><!-- col -->
          <div class="col-xl-4 mg-t-10">
            <div class="card ht-100p">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Шинэ мэдээ</h6>
              </div>
              <ul class="list-group list-group-flush tx-13">
                <li @click="showTask(t)" role="button" class="list-group-item d-flex pd-sm-x-20" v-for="(t,i) in tasks" :key=i>
                  <div class="wd-40">
                    <img :src="`${t.defaultAttachmentUrl}?w=40&h=40&mode=crop`" class="rounded" />
                  </div>
                  <div class="pd-sm-l-10 text-truncate">
                    <p class="tx-medium mg-b-0 text-truncate">{{t.task}}</p>
                    <small class="tx-12 tx-color-03 mg-b-0">{{t.createdDate | moment('from')}}</small>
                  </div>
                  <div class="mg-l-auto text-right">
                    <small class="tx-12 tx-success mg-b-0" v-if="(t.locType!=null)">{{t.locType.name}}</small>
                  </div>
                </li>
                
              </ul>
              <div class="card-footer text-center tx-13">
                <a href="" class="link-03">Бусад <i class="icon ion-md-arrow-down mg-l-5"></i></a>
              </div><!-- card-footer -->
            </div><!-- card -->
          </div>
          <div class="col-xl-4 mg-t-10">
            <div class="card ht-100p">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Монгол эрдэмтэд</h6>
              </div>
              <ul class="list-group list-group-flush tx-13">
                <li @click="showTask(t)" role="button" class="list-group-item d-flex pd-sm-x-20" v-for="(t,i) in tasks2" :key=i>
                  <div class="wd-40">
                    <img :src="`${t.defaultAttachmentUrl}?w=40&h=40&mode=crop`" class="rounded-circle" />
                  </div>
                  <div class="pd-sm-l-10 text-truncate">
                    <p class="tx-medium mg-b-0 text-truncate">{{t.f1}} {{t.task}}</p>
                    <small class="tx-12 tx-color-03 mg-b-0">{{t.i8}} онд сонгогдсон - ({{t.locType1Name}})</small>


                    <!-- <span class="icon">
                    {{t.f1}} <span style="text-transform:uppercase">{{t.task}}</span>
                  </span>
                  <br />
                  <span>{{t.i8}} онд сонгогдсон - ({{t.locType1Name}})</span> -->
                  </div>
                </li>
                
              </ul>
              <div class="card-footer text-center tx-13">
                <a href="" class="link-03">Бусад <i class="icon ion-md-arrow-down mg-l-5"></i></a>
              </div><!-- card-footer -->
            </div><!-- card -->
          </div>
          <div class="col-xl-4 mg-t-10">
            <div class="card ht-100p">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Шинэ нийтлэл</h6>
              </div>
              <ul class="list-group list-group-flush tx-13">
                <li @click="showTask(t)" role="button" class="list-group-item d-flex pd-sm-x-20" v-for="(t,i) in tasks3" :key=i>
                  <div class="wd-40">
                    <img :src="`${t.defaultAttachmentUrl}?w=40&h=40&mode=crop`" class="rounded" />
                  </div>
                  <div class="pd-sm-l-10 text-truncate">
                    <p class="tx-medium mg-b-0 text-truncate">{{t.task}}</p>
                    <small class="tx-12 tx-color-03 mg-b-0">{{t.createdDate | moment('from')}}</small>
                  </div>
                  <div class="mg-l-auto text-right">
                    <small class="tx-12 tx-success mg-b-0" v-if="(t.locType!=null)">{{t.locType.name}}</small>
                  </div>
                </li>
                
              </ul>
              <div class="card-footer text-center tx-13">
                <a href="" class="link-03">Бусад <i class="icon ion-md-arrow-down mg-l-5"></i></a>
              </div><!-- card-footer -->
            </div><!-- card -->
          </div>
        </div>






        </div>

        <b-modal v-model="taskDtl.mdl" size="xl" hide-footer hide-header content-class="rounded-20 pd-20">
          <h3>{{taskDtl.obj.task}}</h3>
          <div v-html="taskDtl.obj.taskDesc"></div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";


export default{
  components:{
    chartMixed: () => ({
      component: import("@/views/home/apps/mori/charts/mixed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    chartMixed1: () => ({
      component: import("@/views/home/apps/mori/charts/mixed1.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data(){
    return{
      tasks: [],
      tasks2: [],
      tasks3: [],

      taskDtl:{
        obj:{
          task: null,
          defaultAttachmentUrl: null,
          taskDesc: null
        },
        mdl: false,
      }
    }
  },
    mounted(){

      let _obj = this.$store.state.app.mainLayoutConfig;
      console.log('obj', _obj)
      _obj.aside = false;
      _obj.header = 201;
      _obj.expanded = false;
      this.handleMainLayoutConfig(_obj);
      this.init();
    },
    methods:{
        ...mapActions(["handleLoading", "handleMainLayoutConfig"]),
        init(){
          this.handleLoading({ isLoading: true });
          request({
            api: { method: "POST", url: "TaskCore/GetCoreList" },
            data: {
              projectId: 52646,
              objectTypeId: 357,
              skip: 0,
              size: 10,
              model: {
                
              }
            },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            this.init2();

            this.tasks= res.data.tasks;
            //console.log("GetCoreList=> ", );
          });
        },
        init2(){
          this.handleLoading({ isLoading: true });
          request({
            api: { method: "POST", url: "TaskCore/GetCoreList" },
            data: {
               model: {
                  isPublic: true,
                  locTypeId1: 40184,
              },
              ot: 357,
              skip: 0,
              size: 10,
              isPublic: true
            },
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJicl9iSFdhUTJrMlRxUzdfX1ZJbmhaIiwic2lkIjoiMTEwNSIsImp0aSI6ImNjYWQ3YjM3LTkxMzAtNDM5MS04ZWJiLWRhYjJlMmYyN2EzMyIsIm5iZiI6MTY3MDY0OTk5OSwiZXhwIjoxNzMzNzIxOTk5LCJpc3MiOiJkeW5hbWljQXBpIiwiYXVkIjoiZHluYW1pY0FwaSJ9.H2pU2FpPe6oy2-u5S6srlNxGHJRosCpV1mXUf76WIxU',
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            this.init3();
            
            console.log('res.data.tasks', res.data.tasks);
            this.tasks2= res.data.tasks;
          });
        },
        init3(){
          this.handleLoading({ isLoading: true });
          request({
            api: { method: "POST", url: "TaskCore/GetCoreList" },
            data: {
              projectId: 52646,
              objectTypeId: 357,
              skip: 30,
              size: 10,
            },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            this.tasks3= res.data.tasks;
          });
        },
      showTask(task){
        this.handleLoading({ isLoading: true });
          request({
            api: { url: "task/taskInheritedDetail", method: "get" },
            params: { id: task.id },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            //console.log('taskDtl', res);
            this.taskDtl.obj= res.data.task;
            this.taskDtl.mdl= true;
          });
      }
    }
}
</script>